<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title> Registration for messaging US recipients </mat-card-title>
    <mat-card-subtitle>
      To send SMS messages to recipients located in the US, provide business details below
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <sms-progress-tracker [stages]="stages$ | async"></sms-progress-tracker>
  </mat-card-content>
  <mat-card-actions>
    <button (click)="openLearnMoreModal()" mat-stroked-button>
      {{ 'SMS_REGISTRATION.INFO_BANNER.LEARN_MORE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
